<script setup lang="ts">
import { defineProps, computed } from "vue";
import { useTheme } from "~/composables/useTheme";

const { colors, themeName } = useTheme();

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: "#0027AF",
  },
  width: {
    type: String,
    default: "auto",
  },
  borderRadius: {
    type: String,
    default: "6px",
  },
});

// Compute width
const computedWidth = computed(() => {
  if (props.width === "full") return "100%";
  if (props.width === "auto") return "auto";
  return props.width;
});

// Theme-based background color
const bgColor = colors.secondaryBadge;

// Theme-based icon color
const iconColor = computed(() =>
  themeName.value === "dark" ? "#FFF" : "#002FA7"
);

// Fixed border color
const borderColor = "#002FA7";
</script>

<template>
  <div
    :style="{
      display: 'flex',
      alignItems: 'center',
      gap: '3px',
      width: computedWidth,
      backgroundColor: bgColor,
      // border: `1px solid ${borderColor}`,
      color: colors.primaryText,
      // borderRadius: borderRadius,
      borderTopLeftRadius: props.borderRadius,
      borderBottomLeftRadius: props.borderRadius,
      // borderTopRightRadius: '0',
      // borderBottomRightRadius: '0',
      borderTopRightRadius: props.borderRadius,
      borderBottomRightRadius: props.borderRadius,
      padding: '4px 8px',
      cursor: 'default',
    }"
  >
    <!-- SVG Icon (Reactive fill color) -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18px"
      viewBox="0 0 24 24"
      width="18px"
      :fill="iconColor"
      style="display: flex"
    >
      <rect fill="none" height="24" width="24" />
      <path
        d="M13.5,5.5c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S12.4,5.5,13.5,5.5z 
           M20,12.5V23h-1V12.5c0-0.28-0.22-0.5-0.5-0.5 
           S18,12.22,18,12.5v1h-1v-0.69c-1.46-0.38-2.7-1.29-3.51-2.52
           C13.18,11.16,13,12.07,13,13c0,0.23,0.02,0.46,0.03,0.69L15,16.5V23h-2v-5
           l-1.78-2.54L11,19l-3,4l-1.6-1.2L9,18.33V13
           c0-1.15,0.18-2.29,0.5-3.39L8,10.46V14H6V9.3l5.4-3.07l0,0.01
           c0.59-0.31,1.32-0.33,1.94,0.03c0.36,0.21,0.63,0.51,0.8,0.85l0,0l0.79,1.67
           C15.58,10.1,16.94,11,18.5,11C19.33,11,20,11.67,20,12.5z"
      />
    </svg>

    <small :style="{ color: colors.quaternaryText }">{{ text }}</small>
  </div>
</template>

<style scoped>
div {
  width: max-content !important;
}
small {
  font-size: 11px;
}

@media (min-width: 1025px) {
  small {
    font-size: 12px;
  }
}
</style>
